"use client";

import { useLanguage } from "@/components/LanguageProvider";
import Link from "next/link";

export default function NotFound() {
  const { t, dir } = useLanguage();

  return (
    <div
      className="flex flex-1 flex-col items-center justify-center px-4 py-24 text-center"
      dir={dir}
    >
      <p className="text-sm font-semibold uppercase tracking-widest text-[var(--accent)]">
        404
      </p>
      <h1 className="mt-2 text-3xl font-extrabold text-[var(--primary)]">
        {t("notfound.title")}
      </h1>
      <p className="mt-4 max-w-md text-slate-600">{t("notfound.subtitle")}</p>
      <Link
        href="/"
        className="mt-8 inline-flex rounded-xl bg-[var(--accent)] px-6 py-3 text-sm font-bold text-[var(--accent-foreground)]"
      >
        {t("notfound.back")}
      </Link>
    </div>
  );
}
